
// ADVANCED SEARCH
// var stands = $.getJSON("src/js/config/filtering/advanced_search.json");
var manifest = $.getJSON("src/js/config/filtering/advanced_search.json");
var blacklist = [];

// $.when( manifest,stands ).then(function( manifest,stands ) {
//     manifest = manifest[0];
//     stands = stands[0];
//     $.each(stands, function(parent,data){
//         if(interfaceIsMobile()) {
//             dropDownMakerArray("#sections-mobile", data, parent);
//         } else {
//             dropDownMakerArray("#sections", data, parent);
//         }
//     });
// });

$('#sections').on('change', function(e){ // On change section selector
    clean('#seat');
    clean('#row');
    var search = manifest.responseJSON[$('#sections').val()];

    if(search===undefined){
        console.error("Seatmanifest error. Section "+$('#sections').val()+ " does not exists");
    }else{
        var sorted_rows = {nums:[],letters:[]};

        jQuery.each(search, function(i,val){
            if(isNumeric(i)){
                sorted_rows['nums'].push(i);
            }else{
                if(sorted_rows.letters[i.length]==null){
                    sorted_rows.letters[i.length]=[];
                }
                sorted_rows.letters[i.length].push(i);
                sorted_rows.letters[i.length].sort();

            }
        });

        var aux = sorted_rows.nums;
        for(var i = 0;i < sorted_rows.letters.length; i++){
           if(sorted_rows.letters[i]!=null){
               aux = aux.concat(sorted_rows.letters[i]);
           }
        }

        for(var i =0; i<aux.length;i++){
            dropDownMaker(aux[i],'#row',aux[i]);
        }

        $('#sections').selectpicker('refresh');
        $('.selectpicker').selectpicker('deselectAll');
    }
});

$('#sections-mobile').on('change', function(e){ // On change section selector
    clean('#seat-mobile');
    clean('#row-mobile');
    var search = manifest.responseJSON[$('#sections-mobile').val()];

    if(search===undefined){
        console.error("Seatmanifest error. Section "+$('#sections-mobile').val()+ " does not exists");
    }else{
        var sorted_rows = {nums:[],letters:[]};

        jQuery.each(search, function(i,val){
            if(isNumeric(i)){
                sorted_rows['nums'].push(i);
            }else{
                if(sorted_rows.letters[i.length]==null){
                    sorted_rows.letters[i.length]=[];
                }
                sorted_rows.letters[i.length].push(i);
                sorted_rows.letters[i.length].sort();

            }
        });

        var aux = sorted_rows.nums;
        for(var i = 0;i < sorted_rows.letters.length; i++){
           if(sorted_rows.letters[i]!=null){
               aux = aux.concat(sorted_rows.letters[i]);
           }
        }

        for(var i =0; i<aux.length;i++){
            dropDownMaker(aux[i],'#row-mobile',aux[i]);
        }

        $('#sections-mobile').selectpicker('refresh');
        $('.selectpicker').selectpicker('deselectAll');
    }
});

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

$('#row').on('change',function(e){ // On change row selector
    clean('#seat');
    jQuery.each(manifest.responseJSON[$('#sections').val()][$('#row').val()], function(i,val){
        val = val.split('-')[2];
        dropDownMaker(val,'#seat',val);
        $('#sections').selectpicker('refresh');
        $('.selectpicker').selectpicker('deselectAll');
    });
});

$('#row-mobile').on('change',function(e){ // On change row selector
    clean('#seat-mobile');
    jQuery.each(manifest.responseJSON[$('#sections-mobile').val()][$('#row-mobile').val()], function(i,val){
        val = val.split('-')[2];
        dropDownMaker(val,'#seat-mobile',val);
        $('#sections-mobile').selectpicker('refresh');
        $('.selectpicker').selectpicker('deselectAll');
    });
});

function dropDownMaker(text, selector, value) {
    $(selector).append('<option value='+value+'>' + text + '</option>');
    $(selector).selectpicker('refresh');
}

function dropDownMakerArray(selector, data, parent) {
    var parent_id = 1;
    if (parent) {
        parent_id = parent.replace(/ /g,'');
    } else {
        parent = 'Section';
    }
    $(selector).append('<optgroup id='+parent_id+' label="'+parent+'">');
    jQuery.each(data,function(key,value){
        var text = value.split('_')[1];
        var id = value;
        if (translation[id]) {
            text = translation[id];
        }
        $(selector).find("optgroup#"+parent_id).append('<option data-tokens="'+parent+'" value='+id+'>' + text + '</option>');
    });
    $(selector).append('</optgroup>');
    $(selector).selectpicker('refresh');
}

function clean(selector){
    $(selector).empty();
    $(selector).selectpicker('refresh');
    $(selector).selectpicker('deselectAll');
}

function urlMaker() {
    var section;
    var row;
    var seat;

    if(interfaceIsMobile()) {
        section = $('#sections-mobile').val();
        row = $('#row-mobile').val();
        seat = $('#seat-mobile').val();
    } else {
        section = $('#sections').val();
        row = $('#row').val();
        seat = $('#seat').val();
    }

    if(section && row && seat) {
        var id = section;
    }

    if(id) {
        viewer.loadMap({
            venue_id: initialConfig.config.venue_id,
            map_id: id
        })
        .then((e) => {
            onLoadD2MSuccess(e);
            viewer.select(`${section}-${row}-${seat}`);
            interfaceSetNodeBC(viewer.getNodeById(`${section}-${row}-${seat}`));
        })
        .catch(onLoadD2MError);
    }

    // window.open('https://3ddigitalvenue.com/3dmap/clients/lords-cricket-ground/view3d.html?share='
    //             + section + '-' + row + '-' + seat);
}